// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
// local
import './ConfirmTableRow.scss';
// views
import DropdownCylinderQtd from 'app/ui/commons/DropdownCylinderQtd';
// actions
import { updateEdit, updateValue, updateCylinderQtd } from 'app/redux/actions/confirmDelivery/data';

class ConfirmTableRow extends Component {
    onEditClicked = () => this.props.dispatch(updateEdit(this.props.date, this.props.row.id, true));

    onSaveClicked = () => this.props.dispatch(updateCylinderQtd(this.props.date, this.props.row.id, this.props.row.counter));

    onInputChange = value => {
        let { row } = this.props;
        let hasChanged = row.cylinderQtdRequested !== row.counter;
        this.props.dispatch(updateValue(this.props.date, row.id, value, hasChanged));
    };

    render() {
        const { row } = this.props;
        const { isPending, isFromYesterday, isSaved, hasChanged, isEdit } = row;
        let cssClass = '';
        if (isPending || !isFromYesterday || hasChanged) {
            cssClass = 'row-changed';
        }
        if (isSaved) {
            cssClass = 'row-saved';
        }
        if (isEdit) {
            cssClass = 'row-edit';
        }
        return (
            <Table.Row className={cssClass}>
                <Table.Cell className="wrap">{row.patient.serviceNumber}</Table.Cell>
                <Table.Cell className="bold uppercase wrap">{row.patient.name}</Table.Cell>
                <Table.Cell className="wrap">{row.supplier.name}</Table.Cell>
                <Table.Cell textAlign="center">{row.cylinderQtdRequested}</Table.Cell>
                <Table.Cell textAlign="center">
                    TOTAIS ENTREGUES{' '}
                    {isEdit ? (
                        <DropdownCylinderQtd maxValue={row.cylinderQtdRequested} minValue={0} value={row.counter} onChange={this.onInputChange} />
                    ) : (
                        row.counter
                    )}
                </Table.Cell>
                <Table.Cell textAlign="center">PENDENTES {row.cylinderQtdRequested - row.counter}</Table.Cell>
                <Table.Cell>
                    <Button onClick={this.onEditClicked} circular icon="pencil" size="mini" className="btn-edit" disabled={isEdit} />
                    <Button onClick={this.onSaveClicked} circular icon="check" size="mini" className="btn-save" />
                </Table.Cell>
            </Table.Row>
        );
    }
}

ConfirmTableRow.propTypes = {
    dispatch: PropTypes.func,
    date: PropTypes.object,
    row: PropTypes.object,
};

export default connect()(ConfirmTableRow);
